import { useFormatMessage } from '../../../../../intl/intl';

export function useCargoMainBtnLang() {
  return {
    cta: useFormatMessage({ id: 'cargo.mainBtn.cta' }),
    close: useFormatMessage({ id: 'cargo.mainBtn.close' }),
  };
}
